module.exports = __webpack_public_path__ + "img/adela-livio.331e9a86.jpg";